import React from 'react';
import NiceModal from '@ebay/nice-modal-react';
import { AppShell } from '@packages/ui/layout';
import { ThemeProvider } from '@packages/ui/theme';
import { BrandingProvider } from '@/context/brandingContext';
import { AuthGate } from '@apps/customer/providers';
import { CustomerNavbar } from '@apps/customer/components/Navbar';
import RoutesContainer from '@/routes/RoutesContainer';
import { useAppShellGuards } from '@apps/customer/hooks/useAppShellGuards';
import ChatbotOverlay from './ChatbotOverlay';
import pingBg from '@/assets/images/pink_background.png';
/**
 * Full authenticated layout — only rendered after AuthGate confirms a session.
 * BrandingProvider, navbar, chatbot, and guards all run safely here.
 */
const AuthenticatedContent: React.FC = () => {
  useAppShellGuards();

  return (
    <BrandingProvider>
      <AppShell
        navbar={<CustomerNavbar />}
        backgroundImage={pingBg}
        padding='none'
        overlay={<ChatbotOverlay />}>
        <RoutesContainer />
      </AppShell>
    </BrandingProvider>
  );
};

const CustomerAppShell: React.FC = () => {
  return (
    <ThemeProvider>
      <NiceModal.Provider>
        <AuthGate publicFallback={<RoutesContainer />}>
          <AuthenticatedContent />
        </AuthGate>
      </NiceModal.Provider>
    </ThemeProvider>
  );
};

export default CustomerAppShell;
